import { styled } from '@mui/system';
import TextField from '@mui/material/TextField';

export const CustomNumberField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px', // ボーダーの角を丸くする
    padding: '0', // デフォルトのパディングをリセット
    '& fieldset': {
      borderWidth: '2px', // ボーダーの厚さを調整
    },
    '& input': {
      fontSize: '12px', // 入力テキストのフォントサイズを変更
      padding: '8px 10px', // テキストフィールド内のテキストのパディングを調整
      height: '100%', // テキスト入力の高さをボックス全体に合わせる
      color: '#f0f0f0', // 入力テキストの色を変更
    },
    backgroundColor: '#1e1e1e', // ボーダー枠内を塗る背景色
  },
  '& .MuiInputLabel-root': {
    transform: 'translate(5px, 8px) scale(1)', // ラベルの位置を調整
    fontSize: '12px', // ラベルのフォントサイズ
    color: '#f0f0f0', // ラベルのテキスト色を変更
  },
  '& .MuiInputLabel-shrink': {
    transform: 'translate(5px, -8px) scale(0.9)', // フォーカス時のラベル位置を調整
  },
});
